import { Component, OnInit } from '@angular/core';
import {BuildInfoService} from '../services/buildinfo.service';

@Component({
  selector: 'app-navigation-sidebar-footer',
  templateUrl: './navigation-sidebar-footer.component.html',
  styleUrls: ['./navigation-sidebar-footer.component.css']
})
export class NavigationSidebarFooterComponent implements OnInit {

  versionInfo = 'Build Version Not Found';

  constructor(private buildInfoService: BuildInfoService) { }

  ngOnInit() {

    this.buildInfoService.getBuildVersion().subscribe( response => {
      this.versionInfo = response.toString();
    });

  }

}
